document.addEventListener('DOMContentLoaded', () => {
  const roots = document.querySelectorAll('section.cbd[id^="cbd-"]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const content = root.querySelector('.cbd__content');
    const rich = root.querySelector('.cbd__richtext');
    const fade = root.querySelector('.cbd__fade');
    const btn = root.querySelector('.cbd__toggle');
    const labelEl = btn ? btn.querySelector('.cbd__toggle-label') : null;
    if (!content || !rich || !btn || !labelEl) return;

    const collapsedHeight = parseInt(content.getAttribute('data-collapsed-height'), 10) || 200;
    const animMs = parseInt(content.getAttribute('data-anim-ms'), 10) || 300;
    const useFade = content.getAttribute('data-use-fade') === 'true' || content.getAttribute('data-use-fade') === '1';
    const startOpen = content.getAttribute('data-expanded') === 'true' || content.getAttribute('data-expanded') === '1';

    content.style.overflow = 'hidden';

    const measureFull = () => {
      const prev = content.style.maxHeight;
      content.style.maxHeight = 'none';
      const full = content.scrollHeight;
      content.style.maxHeight = prev;
      return full;
    };

    const full = measureFull();
    const hasContent = full > 0 && rich.textContent.trim().length > 0;
    const needsToggle = full > collapsedHeight + 2;

    if (!hasContent || !needsToggle) {
      if (btn) btn.style.display = 'none';
      if (fade) fade.style.display = 'none';
      content.style.maxHeight = 'none';
      return;
    }

    content.style.transition = `max-height ${animMs}ms ease`;

    const setCollapsed = () => {
      content.classList.remove('is-expanded');
      content.style.maxHeight = `${collapsedHeight}px`;
      labelEl.textContent = btn.dataset.labelMore || 'READ MORE';
      btn.setAttribute('aria-expanded', 'false');
      btn.classList.remove('is-open');
      if (useFade && fade) fade.style.opacity = '';
    };

    const setExpanded = () => {
      content.style.maxHeight = 'none';
      const fullNow = content.scrollHeight;
      content.classList.add('is-expanded');
      content.style.maxHeight = `${fullNow}px`;
      labelEl.textContent = btn.dataset.labelLess || 'SHOW LESS';
      btn.setAttribute('aria-expanded', 'true');
      btn.classList.add('is-open');
      if (useFade && fade) fade.style.opacity = '0';
    };

    if (startOpen) setExpanded(); else setCollapsed();

    btn.addEventListener('click', () => {
      const isOpen = content.classList.contains('is-expanded');
      const fullNow = measureFull();
      content.style.maxHeight = isOpen ? `${fullNow}px` : `${collapsedHeight}px`;
      requestAnimationFrame(() => {
        if (isOpen) {
          setCollapsed();
          setTimeout(() => {
            root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } , 100);
        } else {
          setExpanded();
        }
      });
    });

    let raf;
    const onResize = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        if (content.classList.contains('is-expanded')) {
          const fullNow = measureFull();
          content.style.maxHeight = `${fullNow}px`;
        } else {
          content.style.maxHeight = `${collapsedHeight}px`;
        }
      });
    };
    window.addEventListener('resize', onResize, { passive: true });
  });
});
